import React, { useEffect, useState } from 'react';

import { CircularProgress, Container, makeStyles, Typography } from '@material-ui/core';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import ReportViewer from './ReportViewer';
import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    minHeight: '95vh',
    width: '100%',
  },
}));

export default () => {
  const classes = useStyles();
  const blocRef = useBlocRefHook('reportViewerBloc');
  const { search } = useLocation();
  const { caseId, token } = queryString.parse(search);
  const [caseInfo, setCaseInfo] = useState();

  useEffect(() => {
    const subscription = blocRef.current.caseInfo$.subscribe(setCaseInfo);
    blocRef.current.getCase(caseId, token);
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!caseInfo) {
    return (
      <Container className={classes.container}>
        <div>
          <CircularProgress />
          <Typography variant="subtitle1">loading, please wait ...</Typography>
        </div>
      </Container>
    );
  }

  return <ReportViewer fullScreen reportViewerBloc={blocRef.current} resources={caseInfo?.reports} token={token} />;
};
